import React from "react";
import { Award } from "lucide-react";

// Product images
const MADURO = "https://customer-assets.emergentagent.com/job_ty-core/artifacts/mww36b3g_Maduro%2010.16.jpg";
const POG_BOTTLE = "https://customer-assets.emergentagent.com/job_ty-core/artifacts/9ng5xdo7_Pog%20Front%20Label%204.26%20w%20bottle.png";

const Story = () => {
  return (
    <div className="bg-[#050505] pt-20" data-testid="story-page">
      {/* Hero */}
      <section className="py-24 sm:py-32">
        <div className="container-main">
          <div className="max-w-4xl">
            <p className="font-subheading text-xs tracking-[0.3em] uppercase text-[#C8A876] mb-6">
              Our Story
            </p>
            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-white mb-8 leading-none">
              Built by<br />
              <span className="gradient-text-maduro">Industry Leaders</span>
            </h1>
            <p className="text-[#A3A3A3] text-xl max-w-2xl">
              8eight8 Beverage Co represents the culmination of decades of expertise in premium spirits, 
              strategic partnerships, and an unwavering commitment to exceptional quality.
            </p>
          </div>
        </div>
      </section>

      {/* POG Partnership */}
      <section className="py-24" data-testid="pog-story-section">
        <div className="container-main">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1">
              <p className="font-subheading text-xs tracking-[0.3em] uppercase text-[#FF6B35] mb-6">
                POG Vodka Story
              </p>
              <h2 className="font-heading text-4xl sm:text-5xl tracking-tight text-white mb-8">
                A Taste of<br />
                <span className="gradient-text-pog">Paradise</span>
              </h2>
              <div className="space-y-6 text-[#A3A3A3] leading-relaxed">
                <p>
                  POG—<strong className="text-[#FF6B35]">Passion Orange Guava</strong>—isn't just a flavor; 
                  it's a piece of Hawaiian culture. As the <strong className="text-white">#7 ranked juice 
                  in the West</strong>, POG has been a beloved refreshment for generations.
                </p>
                <p>
                  Through our exclusive partnership with <strong className="text-white">Meadow Gold</strong>, 
                  we've secured trademark rights to bring POG into the spirits world. The result is a vodka 
                  that captures the essence of tropical paradise in every sip.
                </p>
                <p>
                  Available in 750ml bottles and ready-to-drink cans, POG Vodka brings the taste of Hawaii 
                  to your glass—whether you're crafting cocktails or enjoying straight from the can.
                </p>
              </div>
              <div className="mt-10 p-6 bg-[#1A1025] border border-[#3B1F54]">
                <p className="text-[#FF6B35] text-sm tracking-[0.1em] uppercase mb-2">Partnership</p>
                <p className="text-white text-xl font-heading">Meadow Gold Dairies</p>
                <p className="text-[#A3A3A3] text-sm mt-2">Exclusive trademark rights to POG in spirits</p>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="relative aspect-square bg-gradient-to-br from-[#FF6B35]/20 to-[#8A2BE2]/10 flex items-center justify-center">
                <img 
                  src={POG_BOTTLE}
                  alt="POG Vodka"
                  className="w-3/4 object-contain glow-orange"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sean Williams & Maduro */}
      <section className="py-24 bg-[#0A0A0A]" data-testid="maduro-story-section">
        <div className="container-main">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="relative aspect-square bg-[#141414] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-[#C8A876]/20 to-transparent" />
                <img 
                  src={MADURO}
                  alt="Maduro Tequila"
                  className="w-3/4 object-contain glow-amber"
                />
              </div>
            </div>
            <div>
              <p className="font-subheading text-xs tracking-[0.3em] uppercase text-[#C8A876] mb-6">
                Maduro Tequila Story
              </p>
              <h2 className="font-heading text-4xl sm:text-5xl tracking-tight text-white mb-8">
                The Art of<br />
                <span className="gradient-text-maduro">Darkness</span>
              </h2>
              <div className="space-y-6 text-[#A3A3A3] leading-relaxed">
                <p>
                  Maduro Reposado Oscuro represents a revolution in tequila. Created in partnership with 
                  <strong className="text-white"> Sean Williams</strong>, the master blender for 
                  <strong className="text-[#C8A876]"> Cohiba Cigars</strong>, this isn't just a spirit—it's 
                  an experience crafted for the discerning palate.
                </p>
                <p>
                  "Maduro" in the cigar world signifies ripeness and maturity. "Oscura" means dark, mysterious. 
                  Together, they define a tequila aged in <strong className="text-white">charred oak barrels</strong>, 
                  developing a distinctive dark hue and complex flavor profile.
                </p>
                <p>
                  With rich notes of vanilla, caramel, and subtle smoke, Maduro Tequila was specifically 
                  designed to complement the ritual of enjoying a fine cigar. It's sophistication, bottled.
                </p>
              </div>
              <div className="mt-10 grid grid-cols-2 gap-6">
                <div className="p-6 bg-[#1A1A1A] border border-[#333333]">
                  <p className="text-[#C8A876] text-sm tracking-[0.1em] uppercase mb-2">Co-Creator</p>
                  <p className="text-white text-xl font-heading">Sean Williams</p>
                  <p className="text-[#A3A3A3] text-sm mt-2">Master Blender, Cohiba Cigars</p>
                </div>
                <div className="p-6 bg-[#1A1A1A] border border-[#333333]">
                  <p className="text-[#C8A876] text-sm tracking-[0.1em] uppercase mb-2">Ownership</p>
                  <p className="text-white text-xl font-heading">50%</p>
                  <p className="text-[#A3A3A3] text-sm mt-2">Sean Williams stake</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="py-24" data-testid="mission-section">
        <div className="container-main">
          <div className="max-w-4xl mx-auto text-center">
            <p className="font-subheading text-xs tracking-[0.3em] uppercase text-[#C8A876] mb-6">
              Our Mission
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl tracking-tight text-white mb-8">
              Creating Breakout Brands
            </h2>
            <p className="text-[#A3A3A3] text-xl leading-relaxed mb-10">
              8eight8 Beverage Co exists to create premium spirits that stand apart. Through strategic 
              partnerships, exceptional quality, and deep industry expertise, we're building brands 
              that define moments and create lasting impressions.
            </p>
            <div className="grid md:grid-cols-3 gap-8 mt-16">
              {[
                { title: "Excellence", desc: "Uncompromising quality in every bottle", num: 1 },
                { title: "Partnership", desc: "Collaboration with industry icons", num: 2 },
                { title: "Innovation", desc: "Pushing boundaries in spirits", num: 3 },
              ].map((item) => (
                <div key={item.title} className="text-center">
                  <div className="w-16 h-16 mx-auto mb-4 border border-[#C8A876] flex items-center justify-center">
                    <span className="font-heading text-2xl text-[#C8A876]">{item.num}</span>
                  </div>
                  <h3 className="text-white text-lg font-medium mb-2">{item.title}</h3>
                  <p className="text-[#737373] text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Story;
